module.exports = __webpack_public_path__ + "img/hdzcxy_ewm.1826eeae.jpg";